import * as React from 'react';
import type { PrimaryDropdownProps } from '../types';
import { DropdownNoOptionsWrapper } from './dropdown-no-options-wrapper';
import { DropdownOptionsWrapper } from './dropdown-options-wrapper';
import { cn } from '@utils';
import {
	Body2AccentTypography,
	DropdownButton,
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuTrigger,
} from 'src/components';

export const PrimaryDropdownMenu = <T,>({
	open,
	setOpen,
	options,
	onSelect,
	selected,
	disabled,
	DropdownItemComponent,
	children,
	isLoading,
	NoOptionsComponent,
	lastElementRef,
	checkSelected,
	className,
	dropdownMenuClassName,
}: React.PropsWithChildren<PrimaryDropdownProps<T>>) => {
	const showDropdownMenu: boolean = Boolean(isLoading || options?.length);

	return (
		<DropdownMenu open={open} onOpenChange={setOpen}>
			<DropdownMenuTrigger
				aria-label={'saved-views'}
				className="flex items-center justify-between rounded-md p-0 text-sm font-medium text-gray-700 shadow-xs focus:outline-hidden"
				disabled={disabled}
			>
				<div className="flex gap-1 px-[12px] py-[7px]">
					<Body2AccentTypography
						className={cn('max-w-[145px] text-primary', disabled ? 'text-disabled' : '', className)}
					>
						{selected?.label || ''}
					</Body2AccentTypography>
					<DropdownButton
						isActive={!open}
						ariaControls="dropdown-menu"
						disabled={disabled}
						ariaLabelledBy="dropdown-menu"
					/>
				</div>
			</DropdownMenuTrigger>
			<DropdownMenuContent
				className={cn(
					'flex max-h-[275px] w-[400px] max-w-[100vw] flex-col items-center px-[12px] py-[16px]',
					dropdownMenuClassName
				)}
			>
				{children && <div className="mb-[12px] w-full">{children}</div>}
				{showDropdownMenu && (
					<DropdownOptionsWrapper
						options={options}
						DropdownItemComponent={DropdownItemComponent}
						onSelect={onSelect}
						selected={selected}
						isLoading={isLoading}
						lastElementRef={lastElementRef}
						checkSelected={checkSelected}
					/>
				)}
				{!isLoading && !options?.length && NoOptionsComponent && (
					<DropdownNoOptionsWrapper NoOptionsComponent={NoOptionsComponent} />
				)}
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
